<div class="wrap"
     [style.--size.px]="size"
     [class.activated]="activated"
     [class.pressing]="pressing"
     [class.disabled]="disabled"
     role="button"
     [attr.tabindex]="disabled ? -1 : 0"
     [attr.aria-pressed]="activated"
     [attr.aria-label]="activated ? activatedLabel : label"
     [attr.aria-disabled]="disabled || activated ? true : null"
     (pointerdown)="onPressStart($event)"
     (pointerup)="onPressEnd()"
     (pointerleave)="onPressEnd()"
     (pointercancel)="onPressEnd()"
     (keydown)="onKeyDown($event)"
     (keyup)="onKeyUp($event)">

  <div class="btn" #btnEl>
    <!-- dezente, innere Fortschrittsleiste (kein Ring) -->
    <div class="holdbar"
         *ngIf="showProgressBar && pressing"
         [style.width.%]="progress * 100"></div>

    <span #textEl class="text"
          [style.fontSize.px]="fontSizePx">
      {{ activated ? activatedLabel : label }}
    </span>
  </div>
</div>
